"use strict";
exports.__esModule = true;
exports.getNumberValueInRange = exports.getNumber = void 0;
exports.getNumber = function (stringValue, defaultValue) {
    // undefined => defaultValue
    // null => defaultValue
    // "" => defaultValue
    // "x" => defaultValue
    // "0" => 0
    // '1' => 1
    return stringValue && !Number.isNaN(Number(stringValue))
        ? Number(stringValue)
        : defaultValue;
};
exports.getNumberValueInRange = function (value, defaultValue, min, max) {
    var result = exports.getNumber(value, defaultValue);
    if (result) {
        if (typeof min !== 'undefined' && result < min) {
            result = min;
        }
        else if (typeof max !== 'undefined' && result > max) {
            result = max;
        }
    }
    return result;
};
